import { ReactNode } from 'react';

import {
  selectTranslationsError,
  selectTranslationsLoading,
} from '@vk-hr-tek/core/translations';
import { Box } from '@vk-hr-tek/ui/Box';
import { CircularProgress } from '@vk-hr-tek/ui/CircularProgress';
import {
  HTTP_SERVICE_UNAVAILABLE_STATUS,
  HTTP_INTERNAL_SERVER_ERROR_STATUS,
  HTTP_NOT_FOUND_STATUS,
} from '@vk-hr-tek/core/http';

import { useSelector } from '@app/hooks';
import { WidgetReadySignal } from '@app/context';

import { PageError } from '..';

interface WithTranslationsProps {
  children: ReactNode | ReactNode[];
  loaderComponent?: ReactNode;
}

export const WithTranslations = ({
  children,
  loaderComponent,
}: WithTranslationsProps) => {
  const translationsLoadingStatus = useSelector(selectTranslationsLoading);
  const translationsError = useSelector(selectTranslationsError);

  const errorMessage = `Не удалось получить системные переводы текстов${
    translationsError?.status === HTTP_NOT_FOUND_STATUS
      ? `. Проверьте пути до файлов переводов или проверьте url ресурса для получения переводов`
      : ''
  }`;

  if (translationsLoadingStatus === 'failed') {
    return (
      <WidgetReadySignal>
        <PageError
          status={
            translationsError?.status || HTTP_INTERNAL_SERVER_ERROR_STATUS
          }
          traceId={translationsError?.traceId}
          errorMessage={
            translationsError?.status === HTTP_SERVICE_UNAVAILABLE_STATUS
              ? undefined
              : errorMessage
          }
        />
      </WidgetReadySignal>
    );
  }

  if (translationsLoadingStatus === 'loading') {
    return (
      loaderComponent || (
        <Box display="flex" justifyContent="center" p="32">
          <CircularProgress size={50} />
        </Box>
      )
    );
  }

  //eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
